module.exports = __webpack_public_path__ + "img/pay-success-wechat.5c5cd98a.png";